<template>
  <scroll-animation-unit 
    class="p-accommodationFeature" 
    :data-flipped="flipped">
    <dl class="p-accommodationFeature__description">
      <dt><span class="u-mask" v-html="title"></span></dt>
      <dd class="u-fade">
        <p v-html="text"></p>
      </dd>
    </dl>
    <color-overlay class="p-accommodationFeature__image" :scale="true">
      <img :src="image.url" :alt="image.alt" class="u-cover">
      <img :src="image.url" :alt="image.alt" class="u-cover p-accommodationFeature__grayImage">
    </color-overlay>
  </scroll-animation-unit>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'accommodation-feature',
    props: {
      flipped: {
        type: Boolean,
        default: false
      },
      image: {
        type: Object
      },
      title: {
        type: String
      },
      text: {
        type: String
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/partial/accommodation-feature.vue